import type { TOC } from '@ember/component/template-only';
import onIntersect from '../modifiers/on-intersect.ts';

interface InfiniteScrollTriggerSignature {
  Args: {
    onLoadMore: () => void;
    hasMore: boolean;
    isLoading: boolean;
  };
}

const InfiniteScrollTrigger: TOC<InfiniteScrollTriggerSignature> = <template>
  {{#if @hasMore}}
    <div
      class="text-base-content/50 flex w-full justify-center p-8"
      {{onIntersect @onLoadMore}}
    >
      {{#if @isLoading}}
        <span class="loading loading-spinner loading-md"></span>
      {{else}}
        {{! Invisible buffer triggering load soon but let's show anyway or just rely on threshold }}
      {{/if}}
    </div>
  {{/if}}
</template>;

export default InfiniteScrollTrigger;
